import { kontrolaService } from '../services/kontrola.service';
import Vue from 'vue';

const state = {
    kontrola: [],
    sezona:null,
    pridelovalecid:null
};

const actions = {
    load({ dispatch,commit },{sezona,pridelovalecid,makeEditable}) {
        dispatch('alert/clear', "",{ root: true });
        commit('setSezona', sezona)
        commit('setPridelovalecID', pridelovalecid)
      return kontrolaService.load(sezona,pridelovalecid)
            .then(
                kontrola => {
                  commit('load', kontrola);
                  if(makeEditable)
                  commit('makeEditable') 
                  return kontrola;                   
                } 
                
            );
    },
    loadVse({ dispatch,commit },{sezona}) {
          dispatch('alert/clear', "",{ root: true });
        commit('load');
          commit('setSezona', sezona)
       return  kontrolaService.loadAll(sezona)
            .then(
                kontrola => commit('load', kontrola)
                //,
                //error => commit('getLoggedInFailure', error)
            );
    },
     
    save({ dispatch, commit }) {
     

         console.log("Shranjujem!");
        let sezona=this.state.kontrola.sezona;
        let pridelovalecid=this.state.kontrola.pridelovalecid;
        console.log(this.state);
        dispatch('alert/clear', "",{ root: true });

        this.state.kontrola.kontrola.forEach(item=>{
            item.sezona=sezona;
            item.pridelovalecid=pridelovalecid;
            console.log(item);
            if(item.jeaktivna){
              kontrolaService.save(item)
               .then(
                kontrola => {
                   Vue.set(item,'saved',true);
                     Vue.set(item,'id',kontrola.id);
                     Vue.set(item,'jeaktivna',1);
                    
                },
                error => {
                    console.log(error);
                     Vue.set(item,'saved',false);
                  
                    dispatch('alert/error', "Shranjevanje ni uspelo", { root: true });
                }
            );
            }
            else
             kontrolaService.save(item).then(
                kontrola => {
                 Vue.set(item,'saved',true);
                                      
                },
                error => {
                    console.log(error);
              Vue.set(item,'saved',false);
                  
                    dispatch('alert/error', "Brisanje ni uspelo", { root: true });
                });
            //tukaj naredi ikono, da je shranjvanje uspešno na začetku ali nekje
            //uporabi info, če je prišlo kje do napake!

          });
       
        
    }
};

const mutations = {
  
    load(state, kontrola) {

          if(kontrola)
        state.kontrola=kontrola.map(k=>{
            k["datumkontrole"]=kendo.parseDate(k["datumkontrole"]) 
            return k;
        }
            );   

     
    },
    add(state, item) {
        if(!item.id) {
            //do id
            var minid=state.kontrola.reduce((prev, curr) => prev.id < curr.id ? prev : curr,{id:0}).id;
            if(minid>0)
                minid=0;
            minid--;
            item.id=minid;
        }
        state.kontrola.push(item);
    },
    setSezona(state, item) {
        state.sezona=item;
    },
    makeEditable(state){
        for (var i=0;i<state.kontrola.length;i++){
            let dateStr=state.kontrola[i].veljavnostcertifikataod;
            if(dateStr)
                state.kontrola[i].veljavnostcertifikataod=new Date(dateStr);
            else
                state.kontrola[i].veljavnostcertifikataod=new Date( );
            let updated = Object.assign({}, state.kontrola[i], { inEdit: true });
            state.kontrola.splice(i,1,updated);
        }
        

    },
    setPridelovalecID(state, item) {
        state.pridelovalecid=item;
    },
  
    update(state, item) {
        //state.kultura = kultura;
        //state.kultura;
       
        let updated;
        let itemID = item.id
            let index = state.kontrola.findIndex(p =>
                (JSON.stringify({ ...p }) === JSON.stringify(item) )
                 || itemID && p.id === itemID);
            if (index >= 0) {
                updated = Object.assign({}, item);
                state.kontrola.splice(index,1,updated);
            } else {
                let id = 1;
                state.kontrola.forEach(p => { id = Math.max(p.id + 1, id); });
                updated = Object.assign({}, item, { id: id });
                state.kontrola.unshift(updated);
                index = 0;
            }



        //    return data[index];
        //state.kultura=data;

    },
    remove(state, item) {
        let itemID = item.id
            let index = state.kontrola.findIndex(p =>
                (JSON.stringify({ ...p }) === JSON.stringify(item) )
                 || itemID && p.id === itemID);
                console.log("Brisem!");
                console.log(index);
                console.log(state.kontrola);
                state.kontrola.splice(index, 1);
        
        //    return data[index];
        //state.kontrola=data;

    },
    replace(state, kontrola) {
        state.kontrola = kontrola;
    }
   
};

export const kontrola = {
    namespaced: true,
    state,
    actions,
    mutations
};
